import ContactForm from "../components/contact/ContactForm";
import AppointmentBooking from "../components/contact/AppointmentBooking";
import WhatsAppButton from "../components/contact/WhatsAppButton";

const Contact = () => {
  return (
    <div className="page-container">
      <ContactForm />
      <AppointmentBooking />
      <WhatsAppButton />
    </div>
  );
};

export default Contact;